// Styles and classes copied from the email templates
// See NotificationPlatform repo: UPTagAndEventTagInstructionsEmail_Transform.xslt and SCTagAndEventTagInstructionsEmail_Transform.xslt
export const getEventTagEmailPreviewStyle = () => ({
  emailPreview: {
    paddingBottom: '20px',

    '& .title': {
      fontWeight: 600,
      fontSize: '20px',
      lineHeight: '23px',
      marginBottom: '22px',
    },

    '& ul': {
      listStyle: 'none',
      marginLeft: 0,
      paddingLeft: 0,
    },

    '& .substep': {
      marginTop: '22px',
      fontWeight: 600,
      fontSize: '20px',
      lineHeight: '23px',
    },

    '& .EmailTemplate-instruction': {
      lineHeight: '24px',
      marginTop: '20px',
      marginBottom: '20px',
    },

    '& .EmailTemplate-text': {
      marginTop: '20px',
      marginBottom: '20px',
    },

    '& .text': {
      border: '1px solid #f3f2f1',
      fontWeight: 600,
      paddingTop: '5px',
      paddingBottom: '5px',
      paddingLeft: '25px',
    },

    '& .event-tag-wrapper': {
      paddingTop: '25px',
      paddingBottom: '25px',
    },

    '& .tag': {
      border: '1px solid #f3f2f1',
      paddingTop: '15px',
      paddingBottom: '15px',
      paddingLeft: '25px',
      paddingRight: '25px',
      whiteSpace: 'pre-wrap',
    },
  },
});
